namespace SPA {
	export namespace Realtor {

		import Artifact = Wollmilch.Artifact;
		import BaseHTMLElement = ui.base.BaseHTMLElement;

		export class FinanceBuilder
			extends ObjectDataBuilder<RealtorObjectModel> {

			private m_Parent: JQuery | ui.base.BaseHTMLElement | null;
			private Documents: DocumentManager;
			private m_Form: HTMLFormElement;

			public constructor(data: RealtorObjectModel, documents: DocumentManager) {
				super(data);

				this.m_Parent = null;
				this.Documents = documents;

				this.m_Form = document.createElement('form');
				this.m_Form.method = 'post';
				this.m_Form.className = 'finance-form';

				$(this.m_Form)
					.on('change', 'input', (e) => this.onItemChange(e));
			}

			public rebuild(root: ui.base.BaseHTMLElement | JQuery<HTMLElement>, navigation?: Navigation): FinanceBuilder {
				const basicBox = new ui.Box.Box();

				basicBox.clearTitle();
				// basicBox.addTitle( 'Finanzierungs-Dokumente' );
				basicBox.rebuild(root.empty());
				basicBox.append(ui.$$.h(2, [$('<span>Finanzierungs-Dokumente</span>')]).addClass('segment'));

				this.m_Parent = root;

				// Fetch groups valid for for export
				const financeGroups = this.Documents.getGroups().filter((g) => g.exportable);
				for (const group of financeGroups)
				{
					const groupDocuments = this.Documents.getFilesInGroup(group.id);

					const bodyContainer = ui.$$.div().addClass('finance-body');
					for (const document of groupDocuments)
					{
						bodyContainer.append(this.buildFinanceRow(document));
					}

					// Build each groups document list
					const documentContainer = ui.$$.div().addClass('finance-container')
						.append(this.buildFinanceHeader(group.title))
						.append(bodyContainer)
						.append(this.buildFinanceFooter(groupDocuments))
						.appendTo(this.m_Form);
				}

				basicBox.Root()
					.append(this.m_Form)
					.append(this.buildFinanceSubmit());

				return this;
			}

			private onItemChange(e: JQuery.Event)
			{
				const canSubmit = $(this.m_Form).find('input:checked').length === 0;

				$(this.m_Form).next().find('.btn-primary').attr('disabled', canSubmit);
				$(this.m_Form).next().find('.finance-download').empty();
			}

			private buildFinanceHeader(title: string): JQuery
			{
				const headerObject = ui.$$.div().addClass('finance-header')
					.append(ui.$$.div().addClass('finance-desc').html('<span>' + title + '</span>'))
					.append(ui.$$.div().addClass('finance-status rotate').html('<span>Status</span>'))
					.append(ui.$$.div().addClass('finance-action rotate').html('<span>Hinzufügen</span>'));

				return headerObject;
			}

			private buildFinanceRow(document: IDocument): JQuery
			{
				const row = ui.$$.div().addClass('finance-row');

				const label = ui.$$.label()
					.addClass('finance-desc')
					.text(document.title || document.default_title || 'Titel fehlt');
				const iStatus = ui.$$.i().addClass('finance-status status');

				if (document.filename) {
					label.attr('for', 'doc_collection_' + document.id);
					iStatus
						.addClass('status-ok')
						.append('<i class="fas fa-check">');
				} else {
					iStatus
						.addClass('status-fail')
						.append('<i class="fas fa-times">');
				}
				row.append(label).append(iStatus);

				if (document.filename) {
					// Todo use IDs and fetch file stoarge from database!
					let filename = document.filename;
					if (document.filename.indexOf('http') !== 0)
					{
						filename = app.getRemotePath() + filename;
					}
					const checkBundle = ui.$$.div().addClass('finance-action')
						.append(ui.$$.input()
							.attr('type', 'checkbox')
							.attr('name', 'docCollection[' + document.group_id + '][]')
							.attr('id', 'doc_collection_' + document.id)
							.val(filename)
						);

					row.append(checkBundle);
				}

				return row;
			}

			private buildFinanceFooter(documents: IDocument[]): JQuery
			{
				const hasExportableDocuments = documents.filter((d) => d.id !== 0).length !== 0;
				if (!hasExportableDocuments)
				{
					return ui.$$.div().text('In dieser Gruppe wurden bisher keine Dokumente hochgeladen.');
				}

				const btnProceed = ui.$$.button().addClass('btn btn-primary pull-right').css({borderRadius: 0})
					.html('<i class="fas fa-check-double"></i> <span>Alle auswählen</span>')
					.on('click', (e: Event) => {
						e.preventDefault();

						const checkAll = btnProceed.data('checked') === false || btnProceed.data('checked') === undefined;
						if (checkAll) {
							btnProceed.find('span').text('Alle abwählen');
						} else {
							btnProceed.find('span').text('Alle auswählen');
						}

						btnProceed.closest('.finance-container').find('input').each((idx, el) => {
							(el as HTMLInputElement).checked = checkAll;
						}).first().trigger('change');

						btnProceed.data('checked', checkAll);
					});

				return btnProceed;
			}

			private buildFinanceSubmit(): JQuery
			{
				const btnProceed = ui.$$.button()
					.addClass('btn btn-primary btn-lg')
					.attr({type: 'button', disabled: true, style: 'border-radius: 0; margin-bottom: 10px'})
					.append($('<i class="fa fa-folder-open"></i> <span>Finanzierungsunterlagen zusammenstellen</span>'))
					.on('click', (e: Event) => {
						this.onFinanceFormSubmit(e);
					});

				// footer.append(btnProceed);
				const submitBtn = ui.$$.div().addClass('container-fluid').css({margin: '2em 0'})
					.append(ui.$$.div().addClass('row')
						.append(ui.$$.div().addClass('col-sm-12')
							.append(btnProceed)
							.append(ui.$$.div().addClass('finance-download').css({display: 'inline-block', marginLeft: '2em'}))
						)
					);

				return submitBtn;
			}

			private onFinanceFormSubmit(e: Event) {
				e.preventDefault();

				const submitButton = $(e.currentTarget as EventTarget);
				if (submitButton.data('progress') === true) {
					return;
				}

				submitButton
					.data({html: submitButton.html(), progress: true})
					.html('<i class="fas fa-spinner fa-spin"></i> Finanzierungsunterlagen werden zusammengestellt ...');

				$.getJSON((Wollmilch.useHTTPS ? "https" : "http") + "://" + Wollmilch.URL + 'finance.php', $(this.m_Form).serialize(), (resp) => {
					if (resp.success === false) {
						alert('Fehler beim Erstellen oder Speichern der ZIP-Datei');
					}

					submitButton
						.html(submitButton.data('html'))
						.data('progress', false);

					// Add a download link
					const downloadButton = ui.$$.a().addClass('btn btn-success btn-lg').css({borderRadius: '0'})
						.attr({
							href: resp.zipFile,
							download: resp.zipFile.substr(resp.zipFile.lastIndexOf('/') + 1)
						})
						.html('<i class="fas fa-download"></i> Finanzierungsunterlagen herunterladen');
					submitButton.next().empty().append(ui.$$.div().append('<span>Falls Ihr Download nicht automatisch startet: </span>').append(downloadButton));
					// download(resp.zipFile, resp.zipFile.substr(resp.zipFile.lastIndexOf('/') + 1), 'application/zip');
					// setTimeout(() => {
					// 	const x = new XMLHttpRequest();
					// 	x.open("GET", resp.zipFile, true);
					// 	x.responseType = 'blob';
					// 	x.onload = () => download(x.response, resp.zipFile.substr(resp.zipFile.lastIndexOf('/') + 1), 'application/zip');
					// 	x.send();
					// }, 2500);
				});
			}
		}
	}
}
